import { FC, useCallback } from 'react';
import { Trans } from 'react-i18next';

import { UiButton } from 'src/components/UI/Button';
import { OrganizationOldVerifyPageModelType } from 'src/models/Organization/OldVerify';
import { ROUTE_START_GUIDE_ORGANIZATION } from 'src/routes';
import { hardRedirect } from 'src/utils/hardRedirect';
import { useNsTHelper } from 'src/utils/i18n';

type Props = {
  model: OrganizationOldVerifyPageModelType;
  locale: string;
};

export const OrganizationOldVerifyInPendingVerificationPartial: FC<Props> = ({ model, locale }) => {
  const tHelper = useNsTHelper(locale, 'inPendingSection');

  const completeLater = useCallback(() => {
    hardRedirect(document.referrer || ROUTE_START_GUIDE_ORGANIZATION);
  }, []);

  return (
    <div className="row">
      <div className="col-xs-12">
        <div className="card hoverable text-center">
          <div className="card-content">
            <div className="row">
              <div className="col-sm12">
                <p className="text-center">{tHelper('title')}</p>
                <div className="text-left">
                  <p>
                    <span className="text-in-line thin no-margin">
                      <span>{tHelper('text1', { partnerName: model.PartnerName })}</span>
                    </span>
                  </p>
                  <p>
                    <span className="text-in-line thin no-margin">
                      <span>
                        <Trans ns={locale} i18nKey="inPendingSection.note">
                          <b>1</b>
                        </Trans>
                      </span>
                    </span>
                  </p>
                  <p>
                    <span className="text-in-line thin no-margin">
                      <UiButton tag="a" onClick={completeLater} className="anchor-default text-uppercase">
                        {tHelper('completeLater')}
                      </UiButton>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
